<script>
export default {
  name: 'ItineraryEditPosterColor',
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Color',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clearColor() {
      this.$emit('input', null);
    },
    addColor() {
      this.$emit('input', '#000000');
    },
    updateColor(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<template>
  <div class="color-picker">
    <label class="color-picker__label">{{ label }}</label>
    <div class="color-picker__container">
      <template v-if="value !== null">
        <input
          :value="value"
          :disabled="disabled"
          type="color"
          class="color-picker__input"
          @input="updateColor"
        >
        <v-btn
          :disabled="disabled"
          small
          text
          color="error"
          class="color-picker__clear-btn"
          @click="clearColor"
        >
          <v-icon small>mdi-close</v-icon>
          Clear
        </v-btn>
      </template>
      <v-btn
        v-else
        :disabled="disabled"
        small
        color="primary"
        class="color-picker__add-btn"
        @click="addColor"
      >
        <v-icon small left>mdi-plus</v-icon>
        Add color
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.color-picker {
  &__label {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 4px;
    display: block;
  }

  &__container {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__input {
    width: 100%;
    height: 40px;
    padding: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    cursor: pointer;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  &__clear-btn {
    flex-shrink: 0;
  }

  &__add-btn {
    width: 100%;
    margin: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryEditPosterColor.vue